/**
 * «Мои вопросы» (client-questions; ТЗ 26.10.2026, п.9.7): вопросы организации в Центрику — не чат,
 * а обращения с темой, текстом и вложениями. «Задать вопрос» — здесь или на странице заказа.
 */
import { useState } from 'react'
import { MessageCircleQuestion } from 'lucide-react'
import { useAuth } from '@/app/auth-context'
import { PageHead } from '@/design-system/components/layout/page-head'
import { Button } from '@/design-system/components/primitives/button'
import { AskQuestionDialog } from '@/questions/ask-question'
import { QuestionsList } from '@/questions/questions-list'

export function QuestionsPage() {
  const { refresh } = useAuth()
  const [asking, setAsking] = useState(false)
  const [reloadKey, setReloadKey] = useState(0)

  const ask = (
    <Button
      leftIcon={<MessageCircleQuestion className="size-4 stroke-current" aria-hidden />}
      onClick={() => setAsking(true)}
    >
      Задать вопрос
    </Button>
  )

  return (
    <div>
      <PageHead
        className="mb-4 flex-wrap"
        title="Мои вопросы"
        subtitle="Вопросы в Центрику: ответ придёт сюда и на почту"
        actions={ask}
      />
      <QuestionsList side="client" reloadKey={reloadKey} emptyAction={ask} />
      <AskQuestionDialog
        open={asking}
        onClose={() => setAsking(false)}
        onCreated={() => {
          setReloadKey((k) => k + 1)
          void refresh()
        }}
      />
    </div>
  )
}
